module.exports = "../static/media/B25Binge.cf37f74e.svg";